import { Box, Button, Grid, Slider, styled, SvgIcon, Typography, Stack } from "@mui/material"
const scaleBackgroundImageNDVI = require("../../ressources/trendScaleGraphic/backgroundImageNDVI.png")
const scaleBackgroundImageNDWI = require("../../ressources/trendScaleGraphic/backgroundImageNDWI.png")

interface TrendScaleGraphicProps {
    value: number,
    type: string
};

export default function TrendScaleGraphic({ value, type }: TrendScaleGraphicProps) {
    /**
     * Create a scale image with a svg overlay. Dynamically move the svg overlay to the right position
     * If type NDVI, use the NDVI scale image, if type NDWI use the NDWI scale image
     */



    const offset = 9
    return (<>
        <Grid container justifyContent="center" sx={{ ml: 2 }} >

            <Grid item xs={12} container justifyContent="center">


                <Typography variant="overline">
                    Veränderung
                </Typography>

            </Grid>

            <Grid item xs={12}>

                <Stack direction="row">

                    <Box className="img-overlay-wrap" >
                        <Box
                            component="img"
                            // height="50px"
                            sx={{
                                // Change both or none
                                height: "100%",
                                width: "100%",
                            }}
                            src={type == "NDVI" ? scaleBackgroundImageNDVI : scaleBackgroundImageNDWI}
                        />
                        <Box sx={{ bottom: value + offset, position: "absolute" }}>
                            <SvgIcon viewBox="0 0 47.574 14" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="47.574" height="14" viewBox="0 0 47.574 14">
                                    <g id="Gruppe_264" data-name="Gruppe 264" transform="translate(-9567.99 -9346.275)">
                                        <path id="Polygon_3" data-name="Polygon 3" d="M7,0l7,12H0Z" transform="translate(9579.99 9346.275) rotate(90)" fill="#676767" />
                                        <line id="Linie_12" data-name="Linie 12" x2="21.426" y2="0.1" transform="translate(9581.064 9353.275)" fill="none" stroke="#676767" stroke-width="1" stroke-dasharray="1" />
                                        <path id="Polygon_4" data-name="Polygon 4" d="M7,0l7,12H0Z" transform="translate(9603.564 9360.275) rotate(-90)" fill="#676767" />
                                    </g>
                                </svg>
                            </SvgIcon>
                        </Box>

                    </Box>
                    <Stack direction="column" justifyContent="space-between" pl={1} alignItems="center">


                        <Typography variant="overline" >
                            +
                        </Typography>
                        <Typography variant="overline" >
                            _
                        </Typography>
                    </Stack>

                </Stack>

            </Grid>
        </Grid>

    </>)
}